import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    typeWarehouseLists: []
};
const getters = {
    WarehouseType: state => state.typeWarehouseLists

};

const mutations = {
    WAREHOUSE_TYPE_INFO(state, data) {
        state.typeWarehouseLists = data
    }
};

const actions = {
    WarehouseType(context) {
        axiosGet(`crm/warehouse/types`).then((response) => {
            context.commit('WAREHOUSE_TYPE_INFO', response.data.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
